import { useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '@shared/hooks/useToast';

export const useErrorToast = () => {
  const { toast } = useToast();
  const { t } = useTranslation('marketingModule');
  const lastErrorShown = useRef<string | null>(null);

  const showErrorToast = useCallback((error: string | null) => {
    if (error && error !== lastErrorShown.current) {
      lastErrorShown.current = error;
      toast({
        title: t('toasts.error.title', 'Error'),
        description: error || t('toasts.error.unexpected', 'Error inesperado. Inténtalo de nuevo.'),
        variant: 'destructive',
      });
    }

    // Clear the ref when error is resolved
    if (!error) {
      lastErrorShown.current = null;
    }
  }, [toast, t]);

  const showSuccessToast = useCallback((title: string, description?: string) => {
    toast({
      title,
      description,
      variant: 'default',
    });
  }, [toast]);

  const showExportSuccessToast = useCallback(() => {
    toast({
      title: t('export.success.title', 'Exportación exitosa'),
      description: t('export.success.description', 'El archivo se ha descargado correctamente.'),
      variant: 'default',
    });
  }, [toast, t]);

  const showExportErrorToast = useCallback(() => {
    toast({
      title: t('export.error.title', 'Error de exportación'),
      description: t('export.error.description', 'No se pudo exportar el archivo. Inténtalo de nuevo.'),
      variant: 'destructive',
    });
  }, [toast, t]);

  return {
    showErrorToast,
    showSuccessToast,
    showExportSuccessToast,
    showExportErrorToast,
  };
};